import { useAtomValue } from 'jotai';

import { selectedCountryCodesAtom } from 'common/state/countryState';

export const useSelectedCountryCodes = () => useAtomValue(selectedCountryCodesAtom);
